function PaginationBtn({ isDisable, children }) {
  return (
    <button
      className={`flex items-center ${isDisable && "text-disable-color"}`}
      disabled={isDisable}
    >
      {children}
    </button>
  );
}

export default PaginationBtn;
